import {createSelector, MemoizedSelector} from '@ngrx/store';
import {Empresa, empresasAdapter, EmpresasState} from './empresas.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: EmpresasState): any => state.error;

export const getIsLoading = (state: EmpresasState): boolean =>
  state.isLoading;

export const selectEmpresasState = createSelector(selectFeatures,
  (state: FeaturesState) => state.empresas
);

export const selectAllEmpresas: (state: object) => Empresa[] = empresasAdapter.getSelectors(
  selectEmpresasState
).selectAll;

export const selectEmpresaById = (id: string) =>
  createSelector(
    selectAllEmpresas,
    (allEmpresas: Empresa[]) => {
      if (allEmpresas) {
        return allEmpresas.find(e => e.empresaId === id);
      } else {
        return null;
      }
    }
  );

export const selectEmpresasById = (ids: string[]) =>
  createSelector(
    selectAllEmpresas,
    (allEmpresas: Empresa[]) => {
      if (allEmpresas) {
        return allEmpresas.filter(e => ids.indexOf(e.empresaId) >= 0);
      } else {
        return [];
      }
    }
  );

export const selectEmpresasError: MemoizedSelector<object, any> = createSelector(
  selectEmpresasState,
  getError
);

export const selectEmpresasIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectEmpresasState,
  getIsLoading
);
